import { loginSession } from '../common/common.js';

// 非ログイン状態であればログインフォームにリダイレクト
(async () => {
    const isLogin = await loginSession();
    if (isLogin) {
        window.location.replace('/');
    }
})();

document.addEventListener('DOMContentLoaded',async ()=>{
    if(document.cookie){
        const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
            const[name, value] = cookie.split('=');
            acc[name] = decodeURIComponent(value);
            return acc;
        }, {});
        if (cookies.login_id) {
            document.getElementById('login-id').value = cookies.login_id;
            document.getElementById('login-save').checked = true;
        }
    }

    const response = await fetch('/system/user/login/yamakawa.php',{
        method:'POST',
        headers:{'Content-Type':'application/json'}
    });
    const result = await response.json();
    document.getElementById('yamakawa').value = result.yamakawa;
});

document.getElementById('login-submit').addEventListener('click', async function (event) {
    event.preventDefault();
    const loginId = document.getElementById('login-id').value;
    const loginPass = document.getElementById('login-pass').value;
    const loginSave = document.getElementById('login-save').checked;
    const yamakawa = document.getElementById('yamakawa').value;

    const req = await fetch('/system/user/login/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ loginId, loginPass, loginSave, yamakawa }),
    })
    const res = await req.json();
    if (res.success) {
        if (document.getElementById('login-save').checked) {
            await fetch('/system/user/login/login-save.php');
        }
        window.location.href = '../index.html';
    } else {
        if(res.status == 'withdrawal'){
            window.location.href = '/revival/account_revival.html';
        }else{
            alert(res.message);
        }
    }
});